export default "__VITE_ASSET__CpLyq9wx__"